const isDesktop = window.matchMedia('(min-width: 960px)').matches;
const isTablet = window.matchMedia('(min-width: 768px)').matches;
const isMobile = window.matchMedia('(max-width: 768px)').matches;

export {
    isDesktop,
    isTablet,
    isMobile
}
